export function valueFormatter(number: number, locale: string, currency: string) {
    return new Intl.NumberFormat(locale, {
        notation: 'compact',
        compactDisplay: 'short',
        currency,
        currencyDisplay: 'symbol',
        style: 'currency',
    }).format(number);
}

export function getMonthName(date: Date, locale: string, short = true) {
    return date.toLocaleString(locale, { month: short ? 'short' : 'long' });
}
